import IntegrationsFileImport from "../component/integrationsfileimport/IntegrationsFileImport";
import { SOURCE_CONSTANTS } from "../constants";
import SageIntacctInstruction from "./SageIntacctInstruction";

export default function SageIntacct() {

    return (
        <>
            <IntegrationsFileImport source={SOURCE_CONSTANTS.SAGE_SOURCE} >
                <SageIntacctInstruction />
            </IntegrationsFileImport>
        </>
    );
}